import React, { FunctionComponent, useContext } from 'react';

import styles from './AboutCampaignsLinks.scss';
import { Link } from '../Link/Link';
import { CharityExternalLinks } from '../../../types/__generated__';
import { ColorsContext } from '../../context/ColorsContext';
import { Trans, useTranslation } from 'react-i18next';

type AboutCampaignLinksProps = CharityExternalLinks;
function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const AboutCampaignsLinks: FunctionComponent<AboutCampaignLinksProps> = ({
  privacyUrl,
  termsUrl,
  links,
}) => {
  const textColor = useContext(ColorsContext)?.foregroundColor;
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <>
      <h2
        className="jg-h5 jg-space-mtmd jg-space-mbsm"
        style={{ color: textColor }}
      >
        {t('page.campaignLinks')}
      </h2>
      <ul className={styles.campaignLinks}>
        {links?.map(
          (link, index) =>
            link?.url &&
            link?.type && (
              <li key={index} className="jg-space-mrmd">
                <Link style={{ color: textColor }} href={link?.url}>
                  {capitalizeFirstLetter(link.type)}
                </Link>
              </li>
            ),
        )}
      </ul>

      {privacyUrl && termsUrl && (
        <ul className={styles.campaignLinks}>
          <li className="jg-space-mrmd">
            <Link style={{ color: textColor }} href={privacyUrl}>
              <Trans i18nKey="campaignPrivacyPolicy">
                <span className="jg-sr-only">Campaign</span> Privacy policy
              </Trans>
            </Link>
          </li>
          <li>
            <Link style={{ color: textColor }} href={termsUrl}>
              <Trans i18nKey="campaignTermsOfService">
                <span className="jg-sr-only">Campaign</span> Terms of service
              </Trans>
            </Link>
          </li>
        </ul>
      )}
    </>
  );
};

export default AboutCampaignsLinks;
